exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* styles about font size */\n.labelPrice {\n  font-size: 1em;\n}\n\n.labelPrice-income {\n  font-size: 1.3em;\n}\n\n.price {\n  font-size: 1em;\n  font-style: arial;\n}\n\n.price-income {\n  font-size: 1.3em;\n  font-style: arial;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader!./app/css/calc_bitcoin.css
// module id = 237
// module chunks = 0